import { createFileRoute } from '@tanstack/react-router';
import { candidateStatsQuery } from '@/features/candidates/api';
import { recentImportsQuery } from '@/features/runs/api';
import { sourcesQuery } from '@/features/sources/api';
import { TransferPage } from '@/features/transfer/pages/TransferPage';

export const Route = createFileRoute('/_authed/ops/transfer/')({
  staticData: { help: 'transfer' },
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(recentImportsQuery());
    void queryClient.prefetchQuery(sourcesQuery());
    void queryClient.prefetchQuery(candidateStatsQuery());
  },
  component: TransferPage,
});
